const PAGE_AUTH_TYPES = {
  REQUIRED: 'required',

  OPTIONAL: 'optional',

  UNNECESSARY: 'unnecessary',
} as const;

export const PAGE_LIST = {
  /** ログイン */
  LOGIN: {
    pathname: () => '/login',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: '管理者ログイン',
      description: '',
    },
  },
  /** 充電ステーション */
  HOME: {
    pathname: () => '/',
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'HOME',
      description: '',
    },
  },
  /** 設定 */
  SETTING: {
    pathname: () => '/auth/setting',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: 'SETTING',
      description: '',
    },
  },
  /** 設定 ‐ タグ編集 */
  TAG: {
    pathname: () => '/tag',
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'TAG',
      description: '',
    },
  },
  /** ユーザ新規追加 */
  USER_ADD: {
    pathname: () => '/user/add',
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'USER_ADD',
      description: '',
    },
  },
  /** ユーザ新規追加 */
  USER_DETAIL: {
    pathname: (id?: string) => `/user/${id ? id : ':id'}`,
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'USER_DETAIL',
      description: '',
    },
  },
} as const;
